import { createReactExtension } from '@backstage/core-plugin-api';
import { CustomCard } from '@internal/ui-common';
import { homePlugin } from '@backstage/plugin-home';
import { IncidentsCarousel } from './incidentsCarousel/IncidentsCarousel';
import { NoIncidents } from './noIncidents/NoIncidents';
import { useOngoingIncidents } from './hooks/useOngoingIncidents';
import { useStyles } from './ongoingIncidents.style';

import { ErrorPanel, Progress } from '@backstage/core-components';

export const OngoingIncidents = () => {
  const { cx, classes } = useStyles();

  const {
    ongoingIncidents,
    daysWithoutIncidents,
    lastUpdateTime,
    isLoading,
    error,
  } = useOngoingIncidents();

  if (isLoading) {
    return <Progress />;
  }

  if (error) {
    return (
      <ErrorPanel
        error={
          error || new Error('No data available for ongoing incidents widget.')
        }
      />
    );
  }

  return (
    <div className={cx(classes.ongoingIncidents)}>
      <CustomCard
        title="Ongoing incidents"
        extraInfo={`Last updated: ${lastUpdateTime || ''}`}
      >
        {ongoingIncidents && ongoingIncidents.incidents?.length === 0 ? (
          <NoIncidents daysWithoutIncidents={daysWithoutIncidents} />
        ) : (
          <IncidentsCarousel incidents={ongoingIncidents?.incidents || []} />
        )}
      </CustomCard>
    </div>
  );
};

export const OngoingIncidentsWidget = homePlugin.provide(
  createReactExtension({
    name: 'Ongoing incidents widget',
    component: {
      lazy: () =>
        import('./OngoingIncidents').then(m => {
          const Component = m.OngoingIncidents;
          return () => <Component key={Date.now()} />;
        }),
    },
    data: {
      title: 'Ongoing incidents',
      description: 'Displays real-time updates on active incidents.',
      'home.widget.config': {
        layout: {
          width: { defaultColumns: 6, minColumns: 3 },
          height: { defaultRows: 5, minRows: 5, maxRows: 5 },
        },
      },
    },
  }),
);
